// removed by extract-text-webpack-plugin
module.exports = {"root":"Wr0HL"};


//////////////////
// WEBPACK FOOTER
// ../source/layouts/Page/styles.css
// module id = 1163
// module chunks = 26